/**
 * Resolves the per-company Published Form Template limit from the
 * `CUSTOM_FORMS_V2_TEMPLATE_LIMIT` company setting.
 *
 * Kept in lockstep with the API's `resolvePublishedTemplateLimit`
 * (tp-assist-api `controllers/form_templates.mjs`), which is the real gate:
 * the digits-only test means the count/allowance the UI shows never disagrees
 * with the limit the server actually enforces at publish time.
 *
 * The API accepts ONLY an all-digits string (`/^\d+$/`) and deliberately
 * rejects `parseInt` as too lenient — it coerces `'5abc'` → 5 and `'3.9'` → 3,
 * both of which would show/allow a higher limit than the API enforces. We apply
 * the same rule here, but `String()`-coerce first: unlike the server (where the
 * value is always a string from the V1 Accounts Config blob), the client can
 * hold the setting as a raw number, and `String(5)` → `'5'` keeps those valid.
 *
 * Behaviour: blank/absent/`null`, booleans, negatives, decimals, and
 * partial/non-numeric strings all fall back to the default; a valid limit of 0
 * (block all new publishes) is preserved.
 */
export const DEFAULT_TEMPLATE_LIMIT = 2;

export function resolvePublishedTemplateLimit(rawLimit: unknown): number {
  const value = String(rawLimit).trim();
  return /^\d+$/.test(value) ? Number.parseInt(value, 10) : DEFAULT_TEMPLATE_LIMIT;
}
